import { render, staticRenderFns } from "./mydjList.vue?vue&type=template&id=e28011fc&scoped=true&"
import script from "./mydjList.vue?vue&type=script&lang=js&"
export * from "./mydjList.vue?vue&type=script&lang=js&"
import style0 from "./mydjList.vue?vue&type=style&index=0&id=e28011fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28011fc",
  null
  
)

export default component.exports